/**
 * m3 echo Frontend - Billing Page
 *
 * Admin page for billing module management and tenant module assignments.
 * Follows the Tools.tsx pattern with tabbed interface.
 */

import React, { useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  Tabs,
  Tab,
} from '@mui/material';
import { useUIStore } from '../stores/useUIStore';
import ModulesTab from '../components/billing/ModulesTab';
import TenantsTab from '../components/billing/TenantsTab';
import EbitTab from '../components/billing/EbitTab';
import AnimatedTabPanel from '../components/AnimatedTabPanel';

const tabs = [
  { label: 'Module', key: 'modules' },
  { label: 'Mandanten', key: 'tenants' },
  { label: 'EBIT', key: 'ebit' },
];

export const Billing: React.FC = () => {
  const { billingActiveTab, setBillingTab } = useUIStore();

  // Bounds check for persisted tab state
  useEffect(() => {
    if (billingActiveTab >= tabs.length) {
      setBillingTab(0);
    }
  }, [billingActiveTab, setBillingTab]);

  const safeTabIndex = billingActiveTab < tabs.length ? billingActiveTab : 0;

  return (
    <Box>
      <Typography variant="h5" component="h1" sx={{ mb: 3 }}>
        Billing
      </Typography>

      <Paper>
        <Tabs
          value={safeTabIndex}
          onChange={(_, newValue) => setBillingTab(newValue)}
          variant="scrollable"
          scrollButtons="auto"
        >
          {tabs.map((tab) => (
            <Tab key={tab.key} label={tab.label} />
          ))}
        </Tabs>

        <AnimatedTabPanel value={safeTabIndex} index={0}>
          <ModulesTab />
        </AnimatedTabPanel>

        <AnimatedTabPanel value={safeTabIndex} index={1}>
          <TenantsTab />
        </AnimatedTabPanel>

        <AnimatedTabPanel value={safeTabIndex} index={2}>
          <EbitTab />
        </AnimatedTabPanel>
      </Paper>
    </Box>
  );
};

export default Billing;
